import keyBy from "lodash/keyBy";
import partition from "lodash/partition";
import css from "PFApp/activities/show/activity_page/activity_page.module.scss";
import { ActivitySidePanelFilters } from "PFApp/activities/show/activity_page/parts/tabs/components/activity_side_panel_filters/activity_side_panel_filters";
import { useActivityPropertiesNames } from "PFApp/activities/show/activity_page/parts/tabs/matches/hooks/use_activity_properties_names";
import { useActivityMatches } from "PFApp/activities/show/hooks/use_activity_matches";
import { useFiltersV2Store } from "PFApp/components/filters_v2";
import { Stack } from "PFComponents/containers";
import { FiltersV2 } from "PFTypes/filters_v2";
import { RefObject } from "react";

import { MatchesInformation } from "./matches_information";

type MatchesSidePanelProps = {
  scrollableContainerRef: RefObject<HTMLDivElement | null>;
};

export const MatchesSidePanel = ({ scrollableContainerRef }: MatchesSidePanelProps) => {
  const { matchesFetchState, matchesMeta } = useActivityMatches();

  const schemaPropertiesNames = useActivityPropertiesNames();

  const filters = useFiltersV2Store((state) => state.buffer.mainFilters);

  const [activityFiltersElements, otherFiltersElements] = partition(filters, ({ name }) =>
    schemaPropertiesNames.includes(name!)
  );

  return (
    <Stack gap="spacingLg" className={css.pageCardSidePanel}>
      <MatchesInformation />
      <ActivitySidePanelFilters
        disabled={matchesFetchState === "pending"}
        scrollableContainerRef={scrollableContainerRef}
        filters={keyBy(otherFiltersElements, "name") as FiltersV2}
        activityFilters={keyBy(activityFiltersElements, "name") as FiltersV2}
        scope={matchesMeta?.counters?.filteredProfilesCount as number}
      />
    </Stack>
  );
};
